import { render, staticRenderFns } from "./navigationList.vue?vue&type=template&id=261f748e&scoped=true"
import script from "./navigationList.vue?vue&type=script&lang=js"
export * from "./navigationList.vue?vue&type=script&lang=js"
import style0 from "./navigationList.vue?vue&type=style&index=0&id=261f748e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f748e",
  null
  
)

export default component.exports